import { gql, useLazyQuery } from "@apollo/client";
import axios from "axios";
import { toast } from "react-toastify";

const GET_S3_SIGN_URL = gql`
query getPreSignedUrl($type: String, $name: String, $folderName:String) {
  getPreSignedUrl(type: $type, name: $name, folderName:$folderName)
}
`

export const useFileUpload = () => {
  const [getPreSignedUrl] = useLazyQuery(GET_S3_SIGN_URL);

  const getSignUrlAndPutObject = async (file, keyPrefix, setStateCallback, setIsLoading, folderName) => {

    try {
      const fileExtension = file.type.split("/")[1];

      const { data } = await getPreSignedUrl({
        variables: { type: fileExtension, name: `${keyPrefix}_${+new Date}.${fileExtension}`, folderName: folderName },
      });
      if (data?.getPreSignedUrl) {
        const response = await axios.put(data?.getPreSignedUrl, file, {
          headers: { "Content-Type": file.type },
        });
        if (response?.status === 200) {
          const uploadedUrl = new URL(response.request.responseURL);
          const baseUrl = `${uploadedUrl.origin}${uploadedUrl.pathname}`;

          setStateCallback(baseUrl);
        } else {

          setIsLoading(false);
          toast.error("Failed to upload the file");
        }
      } else {

        setIsLoading(false);
        toast.error("Failed to get pre-signed URL");
      }
    } catch (error) {
      setIsLoading(false);
      if (error) {
        toast.error(error.message || "An error occurred");
      } else {
        toast.error("An unknown error occurred");
      }
    }
  }

  const handleFileUpload = async ({
    event,
    keyPrefix,
    setStateCallback,
    setIsLoading,
    folderName
  }) => {
    const {
      currentTarget: {
        validity,
        files,
      },
      target: { validity: targetValidity,
        files: targetFiles, },
    } = event;
    const fileLength = files?.length || targetFiles?.length;
    setIsLoading(true);
    if (fileLength == 1) {

      const file = files?.[0] || targetFiles?.[0];
      if ((validity.valid || targetValidity.valid) && file) {
        getSignUrlAndPutObject(file, keyPrefix, setStateCallback, setIsLoading, folderName)
      }
    } else {
      for (let i = 0; i < files.length; i++) {
        const file = files[i];

        if (validity.valid && file) {
          await getSignUrlAndPutObject(file, keyPrefix, setStateCallback, setIsLoading, folderName)
        }
      }
    }

  };

  return { handleFileUpload };
};
